import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface KlipfolioFormProps {
  serverErrors?: ServerErrors;
}

export const KlipfolioForm = ({serverErrors}: KlipfolioFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-6 mb-3">
          <InputField name="settings.api_key" label="API Key" required={true} maxLength={40} autoFocus={true} />
        </div>
        <div className="col-6 mb-3">
          <InputField name="settings.data_source_name" label="Data source name" required={true} maxLength={200} />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          In the Klipfolio dashboard, go to the{" "}
          <a href="https://app.klipfolio.com/profile/index" target="_blank">
            My Profile
          </a>{" "}
          page. If necessary, click "Edit" and then "Generate New API Key". Copy the API Key and paste it into the field
          above.
        </div>
        <div className="p-2">
          Enter a name for your data source in the next field. Once you save, you should see the new data source appear
          in Klipfolio under "Library" &gt; "Data Sources".
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/115002536529-Configuring-Klipfolio">
            View {IntegrationModuleInfo[IntegrationModules.KLIPFOLIO].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
